























































import Vue from 'vue'
/* eslint-disable no-console */
import CImageViewer from '~/components/shared/configurable/image/CImageViewer.vue'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
export default Vue.extend({
  components: { CDragScroll, CImageViewer },
  props: {
    fileData: {
      type: Object,
      required: true
    },
    showNames: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    }
  },
  data() {
    return {
      selectedIndex: 0,
      showZoomer: false
    }
  },
  computed: {
    files() {
      const filesArray = []

      if (this.fileData.pdfs && this.fileData.pdfs.filenames.length) {
        const pdfs = this.fileData.pdfs.filenames
        const pdfStaticUrl = this.fileData.pdfs.static_url
        for (let i = 0; i < pdfs.length; i++) {
          const filename = pdfs[i].filename || pdfs[i].filename_key
          filesArray.push({
            originalFilename: pdfs[i].filename,
            filename: pdfs[i].filename,
            thumb: require('~/assets/img/icons/icon_pdf.png'),
            approved: true,
            customName: pdfs[i].custom_name || null,
            type: 'pdf',
            target_url: pdfStaticUrl + filename
          })
        }
      }

      if (this.fileData.images && this.fileData.images.filenames.length) {
        const imgs = this.fileData.images.filenames
        const imgsStaticUrl = this.fileData.images.static_url
        for (let i = 0; i < imgs.length; i++) {
          filesArray.push({
            originalFilename: imgs[i].b,
            filename: imgs[i].filename_key,
            thumb: imgsStaticUrl + imgs[i].t,
            customName: imgs[i].custom_name || null,
            type: 'image',
            target_url: imgsStaticUrl + imgs[i].b
          })
        }
      }

      return filesArray
    },
    filesToShow() {
      return this.files.map(f => {
        return {
          type: f.type,
          url: f.target_url,
          name: f.customName || f.originalFilename || null
        }
      })
    }
  },
  mounted() {
    // preload/cache the pdf icon image
    const image = new Image()
    image.src = require('~/assets/img/icons/certificate.png')
  },
  methods: {
    certiClicked(file) {
      const indx = this.getCertiIndex(file)
      this.selectedIndex = indx
      this.showZoomer = true
    },
    getCertiIndex(file) {
      for (let i = 0; i < this.filesToShow.length; i++) {
        if (this.filesToShow[i].url === file.target_url) {
          return i
        }
      }
      return null
    }
  }
})
